"use strict";

import "./Tooltip.css";

import InfoBox from "./../InfoBox";

const Z_INDEX = 11;
const MAX_WIDTH = 300;

/**
	@param {Object} params
		@param {google.maps.Map} params.map
		@param {google.maps.LatLng} params.position
		@param {String} params.label
		@param {Number} [params.zIndex=11]
		@param {Number} [params.maxWidth=200]
*/

export default class Tooltip extends InfoBox {
	
	constructor( params={} ) {
		
		if (!params.map)
			throw new Error("Missing map");
		
		if (!params.position)
			throw new Error("Missing position");
		
		if (!params.label)
			throw new Error("Missing label");
		
		const container = document.createElement("div");
		container.className = "Tooltip";
		if(params.icon){
			const icon = document.createElement("i");
			icon.classList.add("mdi");
			icon.classList.add("mdi-" + params.icon);
			container.appendChild(icon);
		}
		const label = document.createElement("label");
		label.textContent = params.label;
		container.appendChild(label);
		
		super({
			position: params.position,
			content: container,
			closeBoxURL: "",
			zIndex: params.zIndex !== undefined && params.zIndex !== null ? params.zIndex : Z_INDEX,
			maxWidth: params.maxWidth || MAX_WIDTH,
			alignBottom: true,
			pixelOffset: new google.maps.Size(10, -10)
		});
		
		this.open(params.map);
		
		setTimeout(() => container.classList.add("Shown"));
	}
	
	close() {
		this.getContent().classList.remove("Shown");
		setTimeout(() => super.close(), 200);
	}
	
}


// WEBPACK FOOTER //
// ./src/view/Map/Tooltip/Tooltip.js